define([
	"csi/access/_base",
	"csi/access/access",
	"csi/access/full",
	"csi/access/readOnly"
], function(csiAccess, access, full, readOnly) {

	const configEditRoles = ["Configuration Editor"];
	const configDocumentGeneratorTemplateViewerRoles = ["Document Generator Template Viewer"];

	csiAccess.addViewRoles({
		"_CS_Site": {
			"DocumentGeneratorTemplates": {
				"ImportDocumentGenerator": access(full(configEditRoles)),
				"Preview": access(full(configEditRoles)),
				"UploadTemplate": access(full(configEditRoles)),
				"DGaaSDownloadTemplate": access(full(configEditRoles)),
			}
		},
		"DGaaSTemplateRevision": {
			"__Host__": {
				"Preview": access(full(configEditRoles)),
				"UploadTemplate": access(full(configEditRoles)),
				"DGaaSDownloadTemplate": access(full(configEditRoles)),
			}
		},
		"DocumentContainer": {
			"Documents": {
				"NewFromDocumentTemplate": access(full(configDocumentGeneratorTemplateViewerRoles)),
				"RegenerateDocumentFromTemplate": access(full(configDocumentGeneratorTemplateViewerRoles))
			}
		}
	});

});